<ion-list lines="none">
  <ion-item *ngFor="let rating of ratings">
    <ion-avatar slot="start">
      <ion-img src="../../../../assets/images/icon-hammer.svg" alt="Verified Trade Index (VTI)"></ion-img>
    </ion-avatar>
    <ion-label>{{ rating.productInstallationType.type }}</ion-label>
    <!-- TT-260 item 6: the rank, not the old number. -->
    <ion-badge color="gc-yellow" slot="end">{{ rating.value | vtiRank }}</ion-badge>
  </ion-item>
</ion-list>
